<template>
  <div class="tab-content" v-show="title == selectedTitle">
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { inject, provide } from 'vue'

defineProps({ title: String })
const selectedTitle = inject('selectedTitle')
provide('selectedTitle', selectedTitle)
</script>
<style lang="sass" scoped>
.tab-content
  width: 100%
  background: $colorWhite
</style>
